import { CLASSTING_FULL_AUTH_URL } from '@/config';
import store from '@/store';

const needAuth = auth => (auth === true);
const needTeacherRole = teacherRole => (teacherRole === true);

function beforeEachRoutes(router) {
  router.beforeEach((to, from, next) => {
    const auth = to.meta.requiresAuth;
    const teacherRole = to.meta.requiresTeacherRole;

    /* eslint-disable no-param-reassign */
    if (from.query.parent_ids) {
      to.query.parent_ids = from.query.parent_ids;
    }

    if (from.query.source) {
      to.query.source = from.query.source;
    }
    /* eslint-enable */

    store.dispatch('checkUserToken')
      .then(() => {
        if (needTeacherRole(teacherRole)) {
          const user = store.getters.currentUser;

          if (user.role === 'teacher') {
            next();
          } else {
            next({
              name: 'errors.forbidden',
            });
          }
        } else {
          next();
        }
      })
      .catch(() => {
        if (needAuth(auth)) {
          if (to.query && to.query.source === 'classting') {
            next({
              path: `/mobile_callback/classting?continue_url=${encodeURIComponent(to.fullPath)}`,
              replace: true,
            });
          } else {
            sessionStorage.setItem('continue_url', to.fullPath);
            window.location.href = CLASSTING_FULL_AUTH_URL;
          }
        } else {
          next();
        }
      });
  });
}

export default beforeEachRoutes;



// WEBPACK FOOTER //
// ./src/router/beforeEachRoutes.js